import React, { useEffect, useState } from 'react'
import { FormControl, FormHelperText, Grid, Input, makeStyles, TextField, withStyles } from '@material-ui/core';
import './index.scss'
import { useMedia } from '@commons/media';
import { useTranslation } from 'react-i18next';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Link } from 'react-router-dom';
import parser from 'react-html-parser'
import RootStore from '@stores';
import CopyToClipboard from 'react-copy-to-clipboard';
import FacebookShare from '../FacebookShare';
import NamecardShare from '../NamecardShare';
import WhatsappShare from '../WhatsappShare';
import NameCardPoster from '../NamecardShare/poster';
import { errorCaptured } from '@commons/util';
import ajax from '@commons/api/ajax';
import CONFIG from '@commons/api/config';
import shareArrow from "@assets/img/share-arrow.png"

interface AccountFormProps {
    select: number,
    mgmAccounts: any,
    mgmShares: any,
}

// 自定义 Input 样式
const useStyles = makeStyles({
    inputRoot: {
        flex: 1,
        border: '2px solid #005288',
        padding: '8px 30px',
        fontSize: '16px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        '&:hover': {
            borderColor: '#005288', // 去除 hover 时的边框颜色
        },
        '&:focus': {
            borderColor: '#005288', // 去除 focus 时的边框颜色
        },
        '&$focused': {
            borderColor: '#005288', // 聚焦时的边框颜色（你可以保持聚焦边框的样式，也可以完全去除）
        },
    },
    focused: {
        border: '2px solid #005288',
        borderRadius: '6px',
        borderColor: "#000"
    },
    helperText: {
      fontSize: '24px',
      color: '#f50057', // 错误提示文字颜色
    },
});

const shareIconStyle = makeStyles({
    iconList: {
        display: 'flex',
        justifyContent: 'space-between',
        marginLeft: '15px',
        width: '320px'
    },
    mbIconList: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '80%'
    }
})
const AccountShareV2:React.FC<AccountFormProps> = (props)=> {
    const {
        mgmShares,
        mgmAccounts
    } = props;
    const {
        jwt_token,
        mgmUser,
        langTag,
        mgmRefferCode
    } = RootStore.BasicInfoStore;

    const { mediaClass, mbMatches, mdMatches} = useMedia()
    const classes = useStyles()
    const shareIconClasses = shareIconStyle()
    const {i18n} = useTranslation();
    const [telNumError, setTelNumError] = useState(false);
    const [refferCode, setRefferCode]= useState<string>(mgmRefferCode);
    const [showNamrCard, setShowNameCard] = useState(false);
    const [refferCodeCopied, setRefferCodeCopied] = useState(false);
    const [imgSrc, setImageSrc] = useState("");
    const [showMask, setShowMask] = useState(false);



    const handleCopied = () => {
        setRefferCodeCopied(true);
        setTimeout(() => {
            setRefferCodeCopied(false);
        }, 1000);
    }
    const ShareButtons = (props: any) => {
        const {
            mgmShares,
            mgmCode,
            setShowNameCard
        } = props
        return (
            <div className={mbMatches ? shareIconClasses.mbIconList : shareIconClasses.iconList}>
                <FacebookShare mgmShares={mgmShares} mgmCode={mgmCode}></FacebookShare>
                <WhatsappShare mgmShares={mgmShares} mgmCode={mgmCode}></WhatsappShare>
                <NamecardShare mgmCode={mgmCode} setShowNameCard={setShowNameCard}></NamecardShare>
            </div>
        )
    }

    const getDownloadUrl = async(url:string) => {
        const regex = /^(https?:\/\/[^\/]+)/;
        let uri = url.replace(regex, '');
        uri = uri.slice(1)
        const [err, data] = await errorCaptured(
            ajax.post({
            url: `${CONFIG.API.DOWNLOAD_IMAGE}`,
            config: {
                data: {
                url: uri
                },
                responseType: 'blob'
            }
            })
        )
        if (data) {
            const url = URL.createObjectURL(data);
            setImageSrc(url)
        } else {
            setImageSrc(`${mgmShares.nameCardImage}?t=1111`)
        }
    }

    useEffect(() => {
        setRefferCode(mgmRefferCode);
    }, [mgmRefferCode]);
    
    useEffect(() => {
        getDownloadUrl(`${mgmShares.nameCardImage}`)
    }, [])

    const isWechatMiniProgram = () => {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes('miniprogram') && ua.includes('micromessenger');
    };

    const handleMiniShare = () => {
        setShowMask(flag => !flag)
    }

    return (
        <React.Fragment>
            <Grid container className={`main-account-maxwidth ${mediaClass('account-form')}`}>
                <Grid container item xs={12} justifyContent='center' className='account-form-telnum-login'>
                    <Grid container item className={`${mediaClass('account-form-account-login')}`} direction='column' justifyContent='center' alignItems='center' wrap="nowrap" >
                        <h4 style={{color: 'rgb(0, 82, 136)'}}>
                            <strong>
                                {i18n.t('portal:ReferralCode')}
                            </strong>
                        </h4>
                        <Grid item container className={`${mediaClass('accout-form-login-form-input')} account-form-margin `}>
                            <Grid container justifyContent='center' wrap='nowrap' style={{paddingLeft: '35px'}}>
                                <Grid container style={{maxWidth: '270px'}}>
                                    <FormControl error={telNumError} fullWidth>
                                        <Input
                                            classes={{
                                                root: classes.inputRoot,
                                                focused: classes.focused
                                            }}
                                            disableUnderline={true}
                                            placeholder={""}
                                            disabled
                                            value={refferCode}
                                        />
                                        <FormHelperText className='form-error-text'>
                                            {telNumError ? `${i18n.t('portal:accountLabel')} ${i18n.language === 'zh-HK' ? "錯誤" : "Error"}` : ''}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>
                                <CopyToClipboard text={`https://r.hkbn.net/${refferCode}`} onCopy={handleCopied}>
                                    <div className='telnum-signin'>
                                        {refferCodeCopied ? `${mgmAccounts.copyText}${i18n.t('portal:copySuccess')}`: `${mgmAccounts.copyText}`}
                                        {/* {refferCodeCopied ? '複製成功' : '複製' } */}
                                    </div>
                                </CopyToClipboard>
                            </Grid>
                            {
                                isWechatMiniProgram() ? <Grid alignItems='center' container className='mini-share-content'><span className='mini-share-text'>分享：</span><div className='mini-share-btn' onClick={handleMiniShare}>按此分享您的推薦碼</div></Grid> : <Grid className={'account-share-icon-list'} container alignItems='center' justifyContent='center'>
                                <div>{i18n.t('portal:share')}：</div>
                                <ShareButtons mgmShares={mgmShares} mgmCode={refferCode} setShowNameCard={setShowNameCard}></ShareButtons>
                            </Grid>
                            }

                            <Grid container justifyContent='flex-end' style={{marginTop: '10px'}}>
                                {langTag && <Link to={`/${langTag}/tnc`} className='tnc-button'>{i18n.t('portal:TNC')}</Link>} 
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {showNamrCard && mgmShares && <NameCardPoster mgmShares={mgmShares} mgmCode={refferCode} setShowNameCard={setShowNameCard} imgSrc={imgSrc}></NameCardPoster>}

            <div className={`mini-share-mask ${!showMask ? 'mini-mask-hide' : ''}`} onClick={handleMiniShare}>
                <p className='mini-share-toast'>請點擊右上角“...”進行分享</p>
                <img src={shareArrow} className='mini-share-arrow' />
            </div>
        </React.Fragment>
    )
}

export default AccountShareV2;